import React from "react";

import {WhatsappSupportButton} from "../../../_defaultComponents/WhatsappSupportButton/WhatsappSupportButton";
import {LanguageSwitch} from "../../../_defaultComponents/LanguageSwitch/LanguageSwitch";
import {CustomerFooter} from "../components/customerFooter/CustomerFooter";
import {VigoMapBG} from "../components/vigoMapBG/VigoMapBG";
import {
    Content,
    PageHeaderRow,
    SubPageContainer,
    SubPageContent
} from "./CustomerFluidSubPageLayout.styles";
import {BackButton} from "../components/backButton/BackButton";
import {CandidateLayer} from "../components/candidateLayer/CandidateLayer";
import {CodPaymentMethodSelectionLayer} from "../components/codPaymentMethodSelectionLayer/CodPaymentMethodSelectionLayer";
import {VigoGreenBG} from "../components/vigoGreenBG/VigoGreenBG";
import {useStore} from "hooks/useStore";

const DEFAULT_OPTIONS = {
    showLogo: true,
    showSideMenu: true,
    showBackButton: true,
    showLanguageSwitch: false,
    showContactInfo: true,
    showFooter: true,
    showWhatsappSupportButton: true
};

export const CustomerFluidSubPageLayout = ({
    options = DEFAULT_OPTIONS,
    pageTitle = "",
    children
}) => {
    const stores = useStore();
    return (
        <>
            {/* If user is candidate, then show candidate overlay */}
            <CandidateLayer />
            <CodPaymentMethodSelectionLayer />
            <SubPageContainer>
                <SubPageContent>
                    {/* {options.showLogo ? (
                        <Link to={{pathname: "/musteri"}}>
                            <PanelLogo />
                        </Link>
                    ) : (
                        <></>
                    )} */}
                    {/* {options.showSideMenu ? <CustomerMenu /> : <></>} */}
                    {options.showLanguageSwitch ? <LanguageSwitch /> : <></>}
                    {/* {options.showBackButton || pageTitle ? (
                        <PageHeaderRow>
                            {options.showBackButton ? <BackButton /> : <></>}
                            {pageTitle ? <PageTitle title={pageTitle} /> : <></>}
                        </PageHeaderRow>
                    ) : (
                        <></>
                    )} */}
                    <Content>{children}</Content>
                    {/* {options.showContactInfo ? <ContactInfo /> : <></>} */}
                    {options.showFooter ? <CustomerFooter /> : <></>}
                    {options.showWhatsappSupportButton ? <WhatsappSupportButton /> : <></>}
                </SubPageContent>
                <VigoMapBG />
                <VigoGreenBG />
            </SubPageContainer>
        </>
    );
};
